// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

 
  //PRODUCCION
  //  URL_InspeccionTotal: 'https://infinitback.vca.com.ar/api/',
  //  URL_Token: 'https://infinitback.vca.com.ar/auth/login',

  //VCA  DB LCLSVAP008 (12) TEST url
  URL_InspeccionTotal: 'https://infinittest.vca.com.ar/api/',
  URL_Token: 'https://infinittest.vca.com.ar/auth/login',

 //VCA  DB LCLSVAP008 (12) TEST port 5000
  //  URL_InspeccionTotal: 'http://10.10.0.12:5000/api/',
  //  URL_Token: 'http://10.10.0.12:5000/auth/login',


  //VCA  DB LCLSVAP008 (12) DESARROLLO port 5001
  //  URL_InspeccionTotal: 'http://10.10.0.12:5001/api/',
  //  URL_Token: 'http://10.10.0.12:5001/auth/login',

    //URL_InspeccionTotal: 'http://localhost:8080/api/',
   //URL_Token: 'http://localhost:8080/auth/login',

  // : 192.168.29.183

  codigoAnalitycs: 'G-56EK3G2K19',

  version: 'v. 1.6.7',
};
/*

 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.F
